<template>
  <div
    class="bcc-nav-slider-item__wrap"
    :class="{'is-active': active}"
    @click="clickItem">
    <div class="bcc-nav-slider-item__content">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import mixin from './mixin.js'
export default {
  name: 'BccNavSliderItem',
  mixins: [mixin],
  props: {
    index: {
      required: true
    }
  },
  computed: {
    active () {
      return this.index === this.rootMenu.activeIndex
    }
  },
  watch: {
    active (newVal) {
      if (newVal) {
        let parent = this.$parent
        while (parent && parent.$options.name !== 'BccNavSliderSubMenu') {
          parent = parent.$parent
        }
        if (parent) {
          parent.$emit('setGroup', true)
        }
      }
    }
  },
  mounted () {
    this.rootMenu.addItem(this)
  },
  methods: {
    clickItem () {
      this.rootMenu.$emit('item-click', this)
      this.$emit('item-click', this.index)
    }
  }
}
</script>
